import React from 'react';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const MessageDisplayModal = ({openDisplay}) => {

  return (
    <Dialog
      open={openDisplay}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      maxWidth="md"
      fullWidth
    >
        <Box display="flex" justifyContent="center" mt={2}>
            <img 
            src="/images/logo.png" 
            alt="Trexo Global" 
            style={{ width: "30%", marginBottom: 10 }}
            />
        </Box>
      <DialogContent>
        <DialogContentText sx={{ textAlign: "left", color: "#242428", fontSize: "1.1rem", fontWeight: 600, marginBottom:2 }}>
            {`Your request has been sent to ${process.env.REACT_APP_SUPPORT_MAIL}`}
        </DialogContentText>
        <DialogContentText id="confirmation-dialog-description">
        Our Team will reach out to you shortly.
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

export default MessageDisplayModal;
